module.exports = __webpack_public_path__ + "static/images/star.847f2938d28311aa9fb577319bbcae24.svg";